export default __webpack_public_path__ + "static/media/Error403.c8013848.svg";